module.exports = __webpack_public_path__ + "77861caaafb63075d2b56ea30d74a660.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-pink.png
// module id = 2464
// module chunks = 0